import Control from "ol/control/Control";
import "./loadingAnimation.css";
export default class LoadingAnimation extends Control {
    spinner;
    constructor(settings) {
        const spinner = document.createElement("div");
        spinner.className = "spinner";
        super({ element: spinner });
        this.spinner = spinner;
        settings.addEventListerner({
            onLoadingStatusChange: (isLoading) => this.setVisible(isLoading),
        });
    }
    setVisible(visibile) {
        if (visibile) {
            this.spinner.classList.remove("hidden");
        }
        else {
            this.spinner.classList.add("hidden");
        }
    }
}
